export default __webpack_public_path__ + "static/media/gia_thue_xe_7cho_tai_hanoi.0834bed8.svg";